import script from "./CRM20_006RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM20_006RPT.vue?vue&type=script&setup=true&lang=js"

import "./CRM20_006RPT.vue?vue&type=style&index=0&id=70c5f60c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c5f60c"]])

export default __exports__